export const ProductAction = ({type, data = null}) => {
    return {
        type,
        data
    }
}